export const requestStatus = (request) => {
   return new Promise((resolve, reject) => {
      if (!request) {
         return reject("no request sent");
      }
      const statuses = request.services.filter(service => {
         return service.active;
      }).map(service => {
         return service.is_complete;
      })
      const untouched = statuses.every(status => {
         return !status;
      });
      const finished = statuses.every(status => {
         return status;
      });
      if (untouched) {
         request.status = "untouched";
      } else if (finished) {
         request.status = "finished";
      } else {
         request.status = "unfinished";
      }
      return resolve(request);
   });
}

export const requestStatusSync = (request) => {
   if (!request) {
      return;
   }
   const statuses = request.services.filter(service => {
      return service.active;
   }).map(service => {
      return service.is_complete;
   })
   const untouched = statuses.every(status => {
      return !status;
   });
   const finished = statuses.every(status => {
      return status;
   });
   if (untouched) {
      request.status = "untouched";
   } else if (finished) {
      request.status = "finished";
   } else {
      request.status = "unfinished";
   }
   return request;
}

export const requestStatuses = async (requests) => {
   const updatedRequests = [];
   for (let request of requests) {
      updatedRequests.push(await requestStatus(request));
   }
   return new Promise((resolve, reject) => {
      if (updatedRequests.length === 0) {
         return reject("problem iterating: empty requests array");
      }
      return resolve(updatedRequests);
   });
}

export const uniqueServices = (requests) => {
   // regardless if active or not
   return new Promise((resolve, reject) => {
      if (requests.length === 0) {
         return reject("no requests passed");
      }
      const services = requests.map(request => {
         return request.services.map(service => {
            return service.name
         });
      }).flat();
      const uniqueServices = [...new Set(services)];
      if (uniqueServices.length === 0) {
         return resolve([]);
      }
      return resolve(uniqueServices);
   });
}